import React, { Component } from 'react';
import agent from '../../../agent'
import ACTS from '../../../constants'
import { native, appData, getParameters } from '../../../utils/common'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { store } from '../../../store';
import { push } from 'react-router-redux';

const mapStateToProps = state => ({ ...state.common });

const mapDispatchToProps = dispatch => ({
    onSubmit: (id, password) =>
        dispatch({ type: ACTS.LOGIN, payload: agent.Auth.login(id, password), redirect: true, id }),
    onUnload: () => {
        dispatch({ type: ACTS.LOGIN_UNLOAD })
    }
});

class Login extends Component {
    constructor() {
        super();

        this.state = {
            userId : '',
            password: '',
            saveUserId : false
        }
        const token = agent.getSessionInfo().token;        
        if(token){
            store.dispatch(push('/main?start')); 
            return false; 
        }

        this.isApp = agent.getSessionInfo().isApp;

        //제휴사코드
        this.ac = window.sessionStorage.getItem('ac');
        if(!this.ac){
            this.ac = getParameters('ac');
            if(this.ac){
                window.sessionStorage.setItem('ac', this.ac);
            }
        }
    }; 

    componentDidMount(){  
        if(this.isApp){
            // 데이터 조회
            native().loadData();
            
            // 데이터 조회 콜백
            window.cbQueryKeys = param => {
                const userId = appData('USERID', param.data).get();    
                if(userId != ""){
                    this.setState({saveUserId: true, userId});
                    this.refs.saveUserId.checked = true;
                }
            }
        }else{
            const userId = window.localStorage.getItem('USERID');
            if(userId){
                this.setState({saveUserId: true, userId});
                this.refs.saveUserId.checked = true;
            }
        }
    }
        
    // 아이디 저장
    onChangeSaveUserId = () => {
        this.setState({saveUserId: this.refs.saveUserId.checked});

        if(this.isApp){
            if(this.refs.saveUserId.checked){
                native().saveData("USERID", this.state.userId);
            }else{
                native().saveData("USERID", "");
            }
        }else{
            if(this.refs.saveUserId.checked){
                window.localStorage.setItem('USERID', this.state.userId);
            }else{
                window.localStorage.removeItem('USERID');
            }
        }
    }

    // input 변경
    onChangeInput = key => e => {
        this.setState({[key]: e.target.value});
    }

    onBlurInput = () => {
        this.onChangeSaveUserId();
    }
    
    submit = () => ev => {
        ev.preventDefault();
        const {userId, password} = this.state;

        if(window.$.trim(userId) === ""){
            window.Alert.info("아이디를 입력하세요.",() => {
                this.refs.userId.focus();
            });
            return;
        }else if(window.regExpPattern('email').test(userId) === false){
            window.Alert.info("이메일 형식이 아닙니다.", () => {
                this.refs.userId.focus();
            });
            return;
        }else if(window.$.trim(password) === ""){
            window.Alert.info("비밀번호를 입력하세요.",() => {
                this.refs.password.focus();
            });
            return;
        }

        this.props.onSubmit(window.$.trim(userId), window.$.trim(password));
    }

    getLoginNm = () => {
        let loginNm = "성공하세요";
        if(window.SERVICE_NM === "erp"){
            return <span><span style={{ color: "#0ab3dc" }}>SF</span><span>ERP</span></span>
        }

        return loginNm;
    }

    render(){

        return (                    
            !getParameters('state') &&
                <div className="logBox">
                   
                    <div className="logLogo">
                        { this.getLoginNm() } <strong style={{fontWeight:"bold", color:"#4e54c8", fontSize:"1.5rem" }}>MOBILE</strong>
                        <p style={{ letterSpacing:"-1px" }}>하나의 아이디로 WEB과 APP 모두 로그인 가능</p>
                    </div>

                    <div className="logForm">  
                        <form onSubmit={this.submit()}>
                        <input type="email" className="logInput" placeholder="ID (이메일 형식)" ref="userId" value={ this.state.userId } onChange={ this.onChangeInput('userId') } onBlur={ this.onBlurInput } />
                        <input type="password" className="logInput" placeholder="비밀번호" ref="password" value={ this.state.password } onChange={ this.onChangeInput('password') } />
                        <div className="logAside">
                            <span className="imgChkBox f_lt">
                                <input className="imgChkBoxInput" type="checkbox" id="login_chk" ref="saveUserId" onChange={ this.onChangeSaveUserId } />
                                <label className={ "imgChkBoxLabel" + (this.state.saveUserId ? " lbOn" : "") } htmlFor="login_chk" style={{ fontSize: "13px" , paddingTop: "1px" , letterSpacing:"-1px" , fontWeight:"normal" , color:"#666" }}>아이디 저장</label>
                            </span>
                            <span className="f_rt" style={{ fontSize: "13px" , letterSpacing:"-1px", fontWeight:"normal" }}> 
                                <Link to="/find" style={{color:"#666"}}>아이디 · 비밀번호 찾기</Link>
                            </span>
                            <div style={{ clear: 'both' }}></div>
                        </div>
                        <button className="logBtn" onClick={ this.submit() }>로그인</button>
                        </form>
                        {
                            window.SERVICE_NM !== "erp" && 
                            <div style={{ clear:'both',textAlign:'center',marginTop:'40px',fontSize:'13px' , color:'#666' }}>아직 회원이 아니신가요?
                                <Link to="/join" className="link_text pl10 b" style={{ fontSize:'15px' }}>가입하기</Link>
                            </div>
                        }
                    </div>            
                </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);


// WEBPACK FOOTER //
// ./src/components/pages/member/login.js